import locationCardCompactTpl from './location-card-compact.tpl.html';
import locationCardFullTpl from './location-card-full.tpl.html';
import locationCardNewTpl from './location-card-new.tpl.html';

import navButtonComponentMod from '../../common/material-components/buttons/nav-button.component';
import normalButtonComponentMod from '../../common/material-components/buttons/normal-button.component';
import normButtonComponentMod from '../../common/material-components/buttons/norm-button.component';

import urlServiceMod from '../common/url.service';

/**
 * Displays the details of a location in the locations page
 */
class LocationCardComponent {

  constructor($window, $filter, UrlService) {
    'ngInject';

    this.$window = $window;
    this.$filter = $filter;
    this.UrlService = UrlService;

    /**
     * @type {Location}
     */
    this.locationObj = null;
    this.locationId = null;

    this.showInfo = false;
    this.locationInfoCallback = null;

    /**
     * Is the location card active.
     * @type {boolean}
     */
    this.active = false;

    this.showReserveLink = false;
  }

  $onInit() {
    this.locationId = this.locationObj.domId;

    this.reservationUrl = this.UrlService.reservationURL({[this.locationObj.isArea() ? 'cityId' : 'locationId']: this.locationObj.id})
    .then(url => this.reservationUrl = url);
  }

  onLocationInfoClicked(event) {
    event.stopPropagation();
    this.locationInfoCallback({location: this.locationObj});
  }
}

const config = {
  templateUrl: function($element, $attrs, $log) {
    $log.debug("Determine template for location", $attrs.newMode, $attrs.compactMode);
    if($attrs.newMode === "true") {
      return locationCardNewTpl;
    }
    else if ($attrs.compactMode === "true") {
      return locationCardCompactTpl;
    }
    else {
      return locationCardFullTpl;
    }
  },
  controller: LocationCardComponent,
  bindings: {
    locationObj: '<',
    compactMode: '<',
    newMode: '<?',
    showInfo: '<?',
    locationInfoCallback: '&?',
    active: '<?',
    showReserveLink: '<?'
  }
};

const mod = angular.module('app.locationCard', [
    urlServiceMod,
    navButtonComponentMod,
    normalButtonComponentMod,
    normButtonComponentMod
  ])
.component('locationCard', config)
;

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/locations/location-card.component.js